/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  IShippingAddress,
  ISearchShippingAddressReq,
  ISearchShippingAddressRes,
} from '../interfaces/shipping-address';
import * as baseAdapter from './baseAdapter';

export const queryShippingAddresss = async () => {
  const ret = await baseAdapter.get<IShippingAddress[]>('/shippingAddress');
  return ret;
};

export const getShippingAddress = async (id: number) => {
  const ret = await baseAdapter.get<IShippingAddress>(
    '/shippingAddress/get/' + id,
  );
  return ret;
};

export const searchShippingAddresss = async (
  req: ISearchShippingAddressReq,
) => {
  const ret = await baseAdapter.post<ISearchShippingAddressRes>(
    '/shippingAddress/gets',
    req,
  );
  return ret;
};

export const addShippingAddress = async (data: Partial<IShippingAddress>) => {
  const ret = await baseAdapter.post('/shippingAddress/create', data);
  return ret;
};

export const editShippingAddress = async (data: Partial<IShippingAddress>) => {
  const ret = await baseAdapter.put(`/shippingAddress/update/${data.id}`, data);
  return ret;
};

export const deleteShippingAddress = async (id: number) => {
  const ret = await baseAdapter.deleteRequest(`/shippingAddress/delete/${id}`);
  return ret;
};

export const recoverShippingAddress = async (id: number) => {
  const ret = await baseAdapter.post(`/shippingAddress/recover/${id}`, {});
  return ret;
};

export const importShippingAddress = async (data: IShippingAddress[]) => {
  const ret = await baseAdapter.post<any>(`/shippingAddress/import`, data);
  return ret;
};

export const patchUpdateShippingAddress = async (
  data: Partial<IShippingAddress>,
) => {
  const ret = await baseAdapter.patch(
    `/shippingAddress/patchUpdate/${data.id}`,
    data,
  );
  return ret;
};

export const getMapLatLngFromShortLink = async (link: string) => {
  const ret = await baseAdapter.get<{ lat: string; lng: string }>(
    '/shippingAddress/GetLatLng?url=' + encodeURIComponent(link),
  );
  return ret;
};
